<template>
	<div class="c-people-contacts__filter-bar" v-if="showFilters">

		<button class="c-people-contacts__filter-button"
				v-for="filter in peopleFilters"
				:key="filter"
				:class="{ 'active': selectedFilter === filter }"
				@click="setFilter(filter)">
			{{ filter }}
		</button>

	</div>

	<template v-if="isCarousel">
		<div ref="swiperEl" class="c-people-contacts__carousel swiper">
			<div class="c-people-contacts__slides swiper-wrapper">
				<div class="c-people-contacts__slide swiper-slide" v-for="(item, index) in filteredList" :key="index">
					<person-card :item="item" :toggle-bio="toggleBio" :toggle-contact="toggleContact"></person-card>
				</div>
			</div>
		</div>
	</template>

	<TransitionGroup v-else name="list" tag="div" class="c-people-contacts__container" mode="out-in">
		<person-card :item="item" :toggle-bio="toggleBio" :toggle-contact="toggleContact" v-for="(item, index) in filteredList" :key="index"></person-card>
	</TransitionGroup>

</template>

<script>
	import { nextTick } from 'vue';
	import { TeraSwiper } from 'App/rotator/tera-swiper';

	export default {
		name: 'people-contacts',
		data() {
			return {
				peopleList: [],
				peopleFilters: [],
					selectedFilter: null,
					showFilters: false,
					isCarousel: false,
					podId: null,
					toggleBio: false,
					toggleContact: false,
			}
		},
		mounted() {
			const baseUrl = window.location.origin;

			const DataProp = this.$el.parentElement;
			const DataAPI = DataProp?.getAttribute('data-people-api');
			const DataFilter = DataProp?.getAttribute('data-show-filter');
			const DataLayout = DataProp?.getAttribute('data-layout');
			const DataPodId = DataProp?.getAttribute('data-pod-id');
			const DataToggleBio = DataProp?.getAttribute('data-toggle-bio');
			const DataToggleContact = DataProp?.getAttribute('data-toggle-contact');

			this.showFilters = DataFilter?.toLowerCase() === "true";
			this.isCarousel = DataLayout === "carousel";
			this.podId = DataPodId;
			this.toggleBio = DataToggleBio?.toLowerCase() === "false";
			this.toggleContact = DataToggleContact?.toLowerCase() === "false";

			if (!DataAPI) {
				console.warn('PeopleContacts: data-people-api attribute not found');
				return;
			}

			fetch(baseUrl + DataAPI + (DataAPI.includes('?') ? '&' : '?') + 'sort=position').then(res => res.json()).then(response => {

				this.peopleList = response.items || [];
					this.peopleFilters = response?.filters?.filters[0]?.filterOptions
						?.slice()
						.sort((a, b) => a.sortOrder - b.sortOrder)
						.map(option => option.name) || [];

					// Auto-select the first filter if filters are shown
					if (this.showFilters && this.peopleFilters.length > 0) {
						this.selectedFilter = this.peopleFilters[0];
					}

				if (this.isCarousel) {
					nextTick(() => {
						this.initSwiper();
					});
				}

			}).catch((err) => {

				this.peopleList = [];
				console.error("PeopleContacts fetch error:", err);
			});

		},
		computed: {
			filteredList() {
				const people = Array.from(this.peopleList);

				// If no filter is selected, return all people
				if (!this.selectedFilter) {
					return people;
				}

				// Filter people by selected category
				return people.filter(person => {
					if (!person.categories || !Array.isArray(person.categories)) {
						return false;
					}
					return person.categories.some(cat => cat.name === this.selectedFilter);
				});
			},
		},
		methods: {
			setFilter(filterName) {
					// If clicking the same filter and it's the first one, don't deselect it
					if (this.selectedFilter === filterName && filterName === this.peopleFilters[0]) {
						return;
					}
					// Toggle filter: if clicking the same filter, clear it; otherwise set it
					if (this.selectedFilter === filterName) {
						this.selectedFilter = null;
					} else {
						this.selectedFilter = filterName;
					}
				},
			initSwiper() {
				const $rotator = this.$refs.swiperEl;

				if (!$rotator) {
					console.warn('PeopleContacts: swiper element not found');
					return;
				}

				const $controlParent = $rotator.closest('.c-people-contacts')?.querySelector('.c-people-contacts__control');

				const settings = {
					wrapperClass: 'c-people-contacts__slides',
					slideClass: 'c-people-contacts__slide',
					loop: false,
					containerQuery: true,
					spaceBetween: 20,
					slidesPerView: 1.2,
					breakpoints: {
						767: { slidesPerView: 2 },
						1024: { slidesPerView: 3 },
						1280: { slidesPerView: 4 }
					},
					navigation: {
						nextEl: `.c-people-contacts__control-next[data-pod-id="${this.podId}"]`,
						prevEl: `.c-people-contacts__control-prev[data-pod-id="${this.podId}"]`,
					},
				};

				TeraSwiper.init($rotator, settings, $controlParent);
			}
		}
	};
</script>